<script>
    export let value;
    export let rowIndex;
    export let rowId;
    export let instructKey;

    $: data = value;
</script>
<style>
a {
    position: relative;
    z-index: 99999999999;
}
</style>

<a href='{`/tag/${data["id"]}`}' title="Ver">{data.label}</a>